// client/src/dnd/emitter_tool/hooks/overlay/shapes/dot.js
export default function drawDot(g, _app, { origin, settings = {} }) {
  const angleDeg = Number(settings.angleDeg ?? settings.rotationDeg ?? 0);
  const angleRad = (angleDeg * Math.PI) / 180;

  // visual indicator (unchanged)
  try {
    g.lineStyle({ width: 2, color: 0x00d4ff, alpha: 1 });
  } catch {
    g.lineStyle(2, 0x00d4ff, 1);
  }
  g.drawCircle(origin.x, origin.y, 4);

  // return a directional vector so the emitter can fire toward that angle
  const dirX = Math.cos(angleRad);
  const dirY = Math.sin(angleRad);

  return {
    origin: { x: origin.x, y: origin.y },
    direction: { x: dirX, y: dirY },
    angleRad,
    angleDeg,
  };
}
